// const bodyScrollLock = require('body-scroll-lock');
// const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default class Menu {


  // Constructor
  constructor(triggersSelectors, menuItemsSelectors, pageItemsSelectors) {

    var i, ii, l, ll, items;

    this.triggerItems = [];
    for (i = 0, l = triggersSelectors.length; i < l; i++) {
      items = Array.prototype.slice.call(document.querySelectorAll(triggersSelectors[i]), 0);
      for (ii = 0, ll = items.length; ii < ll; ii++) {
        this.triggerItems.push(items[ii]);
      }
    }

    this.menuItems = [];
    for (i = 0, l = menuItemsSelectors.length; i < l; i++) {
      items = Array.prototype.slice.call(document.querySelectorAll(menuItemsSelectors[i]), 0);
      for (ii = 0, ll = items.length; ii < ll; ii++) {
        this.menuItems.push(items[ii]);
      }
    }

    // this.menus = [];
    // for (i=0, l=menusSelectors.length; i<l; i++) {
    // 	items = Array.prototype.slice.call(document.querySelectorAll(menusSelectors[i]), 0);
    // 	for (ii=0, ll=items.length; ii<ll; ii++) {
    // 		this.menus.push(items[ii]);
    // 	}
    // }

    this.pageItems = [];
    for (i = 0, l = pageItemsSelectors.length; i < l; i++) {
      items = Array.prototype.slice.call(document.querySelectorAll(pageItemsSelectors[i]), 0);
      for (ii = 0, ll = items.length; ii < ll; ii++) {
        this.pageItems.push(items[ii]);
      }
    }

    this.triggerClick = this.triggerClick.bind(this);


    this.menus = document.querySelectorAll('.nav-primary')

  }


  // Public Methods - Lifecycle
  destroy() {
    this.disable();
    delete this.menuItems;
    delete this.pageItems;
    delete this.triggerItems;
  }
  enable() {
    for (var i = 0, l = this.triggerItems.length; i < l; i++) {
      this.triggerItems[i].addEventListener('click', this.triggerClick);
    }
    this.updateState();
  }
  disable() {
    this.menuItems.forEach(function (item) {
      item.removeAttribute('aria-hidden');
      item.removeAttribute('tabindex');
    });
    this.pageItems.forEach(function (item) {
      item.removeAttribute('aria-hidden');
      item.removeAttribute('tabindex');
    });
    for (var i = 0, l = this.triggerItems.length; i < l; i++) {
      this.triggerItems[i].removeEventListener('click', this.triggerClick);
    }
  }


  // Public Methods - States
  showMenu() {
    // window.scrollTo(0, 0);
    document.body.classList.add('show-menu');
    this.updateState();

    // this.menus.forEach(function (menu) {
    //   disableBodyScroll(menu)
    // })
  }
  hideMenu() {
    document.body.classList.remove('show-menu');
    document.body.classList.add('menu-closing');

    setTimeout(() => {
      document.body.classList.remove('menu-closing');
    }, 1500);

    this.updateState();
    // this.menus.forEach(function (menu) {
    //   enableBodyScroll(menu)
    // })
  }


  // Event Handlers
  triggerClick(event) {
    event.preventDefault();
    document.activeElement.blur();
    if (document.body.classList.contains('show-menu')) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  // Helpers
  updateState() {
    if (this.viewingModal) {
      this.menuItems.forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      });
      this.pageItems.forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      });
      return;
    }
    if (document.body.classList.contains('show-menu')) {
      this.menuItems.forEach(function (item) {
        item.removeAttribute('aria-hidden');
        item.removeAttribute('tabindex');
      });
      this.pageItems.forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      });
    } else {
      this.menuItems.forEach(function (item) {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      });
      this.pageItems.forEach(function (item) {
        item.removeAttribute('aria-hidden');
        item.removeAttribute('tabindex');
      });
    }
  }

  // menuGeneralClick() {
  // 	this.menu.forEach((trigger) => {
  // 		trigger.classList.remove('active')
  // 	})
  // }
}
